import React, { forwardRef } from "react";
import { cn } from "./cn";

const Textarea = forwardRef(function Textarea(
  { label, error, hint, className, containerClassName, rows = 3, ...props },
  ref
) {
  return (
    <div className={cn("w-full", containerClassName)}>
      {label && (
        <label className="mb-1.5 block text-start text-sm font-medium text-ink/90">{label}</label>
      )}
      <textarea
        ref={ref}
        rows={rows}
        className={cn(
          "w-full rounded-xl border bg-surface-2 px-3.5 py-2.5 text-sm text-ink outline-none transition",
          "placeholder:text-faint border-line focus:border-accent focus:ring-2 focus:ring-accent/30",
          error && "border-red-400 focus:border-red-400 focus:ring-red-400/30",
          className
        )}
        {...props}
      />
      {error ? (
        <p className="mt-1 text-start text-xs text-red-500">{error}</p>
      ) : hint ? (
        <p className="mt-1 text-start text-xs text-muted">{hint}</p>
      ) : null}
    </div>
  );
});

export default Textarea;
